/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { buildCategoryEventName } from '../utils/buildCategoryEventName';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';

export default (set, get, payload) => {
  const { eventName } = payload;
  set(produce(get(), (draft) => {
    if (!draft.digitalData) {
      draft.digitalData = { event: [] };
    }

    const { category, eventInfo } = buildCategoryEventName('overlay', eventName);
    const event = {
      category,
      eventInfo,
    };

    const eventClone = _cloneDeep(event);
    draft.digitalData.event.push(event); // store cumulative event
    Analytics.sendAnalyticsEvent(eventClone);
  }), false, { type: 'EDIT_WALL_OVERLAY_EVENT' });
};
